import { PropsWithChildren, ReactElement } from "react";
import styles from "./ErrorPageContainer.module.less";

/** NOTE: Temporary component which is used until we have public layout in react */
export const ErrorPageContainer = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	return (
		<div className={styles.root}>
			{children}
		</div>
	);
};
ErrorPageContainer.displayName = "ErrorPageLayout";